import React from 'react';
import style from './style.scss';

const MaxQuantity = (props) => {

    const unitMultiplier = props.unitMultiplier || 1;
    const max = (props.max * unitMultiplier);
    const measurementUnit = props.measurementUnit || 'un.'
    
    return (
        <div className="product-max-quantity-wrap">
            <div className="product-max-quantity-text">Máximo de {max} {measurementUnit}</div>
        </div>
    )
}

export default MaxQuantity;
